import React from "react";
import { motion } from "framer-motion";
import { Helmet } from "react-helmet"; // 👈 import Helmet
import { FaAward, FaUsers, FaStethoscope, FaLeaf, FaDog } from "react-icons/fa";
import "../styles/About.css";

export default function About() {
  return (
    <motion.section
      className="about-section"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.8 }}
    >
      {/* ✅ Helmet SEO */}
      <Helmet>
        <title>About Cary DeClerck | DeClerck’s Goldens</title>
        <meta
          name="description"
          content="Meet Cary DeClerck, a dedicated Golden Retriever breeder with over 20 years of experience. Learn about his family, farm life, and commitment to raising healthy, confident puppies."
        />

        {/* Open Graph */}
        <meta property="og:title" content="About Cary DeClerck | DeClerck’s Goldens" />
        <meta
          property="og:description"
          content="Discover the story of Cary DeClerck and his family’s passion for raising healthy, family-ready Golden Retriever puppies on their farm."
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.declercksgoldens.com/about" />
        <meta property="og:image" content="https://www.declercksgoldens.com/cary.png" />

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="About Cary DeClerck | DeClerck’s Goldens" />
        <meta
          name="twitter:description"
          content="Learn about Cary DeClerck, his family, and their dedication to raising Golden Retriever puppies with love and care."
        />
        <meta name="twitter:image" content="https://www.declercksgoldens.com/cary.png" />

        {/* Canonical */}
        <link rel="canonical" href="https://www.declercksgoldens.com/about" />
      </Helmet>

      {/* Header/Hero */}
      <div className="about-header">
        <img
          src="/cary.png"
          alt="Cary DeClerck, Golden Retriever Breeder"
          className="about-photo"
        />
        <div className="about-intro">
          <h2>Meet Cary DeClerck</h2>
          <div className="about-tagline">
            Breeder. Grandpa. Animal lover.<br />
            The heart and hands behind DeClerck’s Goldens.
          </div>
          <p>
            My name is Cary DeClerck and I have been raising golden retrievers for over twenty years...
          </p>
        </div>
      </div>

      {/* Icon Cards */}
      <div className="about-cards">
        <div className="about-card">
          <FaAward className="about-icon" />
          <h3>Years of Experience</h3>
          <p>
            I have spent decades learning what makes a great golden retriever...
          </p>
        </div>
        <div className="about-card">
          <FaUsers className="about-icon" />
          <h3>Family Raised</h3>
          <p>
            My wife and I have seven kids and a big crew of grandkids...
          </p>
        </div>
        <div className="about-card">
          <FaLeaf className="about-icon" />
          <h3>Farm Life</h3>
          <p>
            This is not just a kennel. Our goldens get to explore open space...
          </p>
        </div>
        <div className="about-card">
          <FaStethoscope className="about-icon" />
          <h3>Health and Honesty</h3>
          <p>
            I keep clear health records for every puppy...
          </p>
        </div>
      </div>

      {/* Story & Values */}
      <div className="about-story">
        <h3 className="about-section-title">
          <FaDog style={{ marginRight: 8 }} />
          The DeClerck Difference
        </h3>
        <p>
          Raising goldens is personal to me. I do not see this as just a business...
        </p>
      </div>

      {/* Quote */}
      <div className="about-quote">
        <blockquote>
          “Every puppy leaves our farm confident, loved, and ready for your family, from our home to yours.”
        </blockquote>
        <div className="about-cite">— Cary DeClerck</div>
      </div>

      {/* Actions */}
      <div className="about-actions">
        <a href="/puppies" className="about-btn-primary">See Available Puppies</a>
        <a href="/contact" className="about-btn-outline">Contact Cary</a>
      </div>
    </motion.section>
  );
}
